module.exports = __webpack_public_path__ + "static/media/product-suite.596921b2.jpg";